import { injectIntl } from 'react-intl';

import { xingConnect } from '@xingternal/xing-frame-provider';

import SettingsDropdown from './SettingsDropdown';
import settingsSelector from './selectors';

/*
 *  CONNECT WITH FRAME DATA
 */
export default xingConnect(settingsSelector)(injectIntl(SettingsDropdown));
